import { gql } from 'graphql-tag';

export const CREATE_PROPOSAL = gql`
  mutation CreateProposal($input: CreateProposalV2Input!) {
    createProposalV2(input: $input) {
      id
      success
      errorMessage
      vendorOpportunityId
    }
  }
`;
